module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), (!_vm.loading) ? _c('div', {
    staticClass: "content past"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('router-link', {
    attrs: {
      "to": {
        "path": "/exhibitions"
      }
    }
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("exhibitions")])]), _c('h4', {
    staticClass: "status h-sm"
  }, [_vm._v("past")])], 1), _c('div', {
    staticClass: "col-8 years",
    attrs: {
      "data-push-left": "off-0_xs-4"
    }
  }, _vm._l((_vm.years), function(year) {
    return _c('router-link', {
      key: year.title,
      staticClass: "h-l bold",
      attrs: {
        "to": {
          name: 'exhibitions-overview',
          params: {
            year: year.title
          }
        }
      }
    }, [_vm._v(_vm._s(year.title))])
  }))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56c75f21"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExhibitionsPast.vue
// module id = 239
// module chunks = 1